// 接口地址
const BASE_API_URL =  process.env.NODE_ENV === 'development' ? process.env.VUE_APP_DEV_BASE_API : process.env.VUE_APP_BASE_API

export default {
    BASE_API_URL
}
